module.exports = __webpack_public_path__ + "media/images/lesson_5/ana_adivinhadora-92c9cf831bdb71bd7806b2cdec9b8690.png";